import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Header from './components/common/Header';
import Navigation from './components/common/Navigation';
import Footer from './components/common/Footer';
import AppRoutes from './routes/Routes';

const App = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <Router>
      <CartProvider>
        <div className="bg-navy text-gray-100 font-sans">
          <div className="bg-secondary text-white text-center py-2 text-sm">
            Free shipping on orders over $75!
          </div>

          <Header
            mobileMenuOpen={mobileMenuOpen}
            setMobileMenuOpen={setMobileMenuOpen}
          />
          <Navigation mobileMenuOpen={mobileMenuOpen} />

          <AppRoutes />

          <Footer />
        </div>
      </CartProvider>
    </Router>
  );
};

export default App;